import React, { Component } from 'react'
import {
	RefreshIcon,
	ChevronRightIcon,
	DocumentTextIcon } from '@heroicons/react/outline'
import InfoTip from './InfoTip'

function fmt(n)
{
	if (n === null || n === undefined)
		return '0'
	return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

class StatsBreakdownCard extends Component {
	render() {
		if (this.props.loading === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse h-full">
					<div className="h-3 bg-slate-200 rounded-full w-1/4 mb-4"></div>
					<div className="space-y-3">
						<div className="h-6 bg-slate-100 rounded"></div>
						<div className="h-6 bg-slate-100 rounded w-5/6"></div>
						<div className="h-6 bg-slate-100 rounded w-2/3"></div>
						<div className="h-6 bg-slate-100 rounded w-3/4"></div>
					</div>
				</div>
			)
		}
		if (this.props.error === true || !this.props.breakdown)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 h-full">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-2">Pages les plus consultées</h2>
					<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Données indisponibles.</p>
					<button
						type="button"
						onClick={this.props.onRetry}
						className="inline-flex items-center gap-1.5 px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
					>
						<RefreshIcon className="w-4 h-4" aria-hidden="true" />
						Réessayer
					</button>
				</div>
			)
		}
		const pages = this.props.breakdown.topPages || []
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 h-full">
				<div className="flex items-center gap-1 mb-4">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0">Pages les plus consultées</h2>
					<InfoTip text="Les contenus que vos campeurs ouvrent le plus. Idéal pour repérer ce qui les intéresse." />
				</div>
				{pages.length === 0
					? (
						<div className="flex items-center gap-3">
							<div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
								<DocumentTextIcon className="w-5 h-5 text-slate-400" aria-hidden="true" />
							</div>
							<p className="text-sm font-medium text-slate-500 my-0">Pas encore de page consultée sur cette période.</p>
						</div>
					)
					: (
						<div className="space-y-3">
							{pages.map((page, index) => {
								const breadcrumb = page.breadcrumb || []
								const max = Math.max.apply(null, pages.map(p => p.views).concat([1]))
								return (
									<div key={index} className="flex items-center gap-3">
										<span className="text-xs font-black text-slate-400 w-5 flex-shrink-0 text-center">{index + 1}</span>
										<div className="flex-1 min-w-0">
											{breadcrumb.length > 0 &&
												<div className="flex items-center flex-wrap gap-x-1 mb-0.5">
													{breadcrumb.map((part, i) => (
														<span key={i} className="inline-flex items-center text-2xs font-bold text-slate-400 uppercase tracking-wide">
															{i > 0 && <ChevronRightIcon className="w-3 h-3 mx-0.5 text-slate-300" aria-hidden="true" />}
															{part}
														</span>
													))}
												</div>
											}
											<p className="text-sm font-bold text-slate-800 my-0 truncate">{page.label}</p>
										</div>
										<div className="flex items-center gap-2 flex-shrink-0">
											<div className="w-24 h-1.5 bg-slate-100 rounded-full overflow-hidden">
												<div className="h-full bg-indigo-400 rounded-full" style={{ width: Math.round((page.views / max) * 100) + '%' }}></div>
											</div>
											<span className="text-sm font-black text-slate-600 w-12 text-right">{fmt(page.views)}</span>
										</div>
									</div>
								)
							})}
						</div>
					)
				}
			</div>
		)
	}
}

export default StatsBreakdownCard
